@let t = data().ongletTransmission;

<div class="info-grid">
  @if (t.input_heureArrivee) {
  <span class="label">Arrivée</span>
  <span class="value">
    <span class="time-badge secondary">
      <mat-icon>schedule</mat-icon>
      {{ t.input_heureArrivee | carnetHeure }}
    </span>
    @if (t.select_personneAccompagnanteArrivee) {
    <span class="muted">par {{ t.select_personneAccompagnanteArrivee }}</span>
    }
    @if (t.input_autrePersonneAccompagnante) {
    <span class="muted">(et {{ t.input_autrePersonneAccompagnante }})</span>
    }
  </span>
  }

  @if (getVenuAvecLabels().length > 0) {
  <span class="label">Venu avec</span>
  <span class="value chips-row">
    @for (item of getVenuAvecLabels(); track item) {
    <mat-chip class="chip-small">{{ item }}</mat-chip>
    }
  </span>
  }

  @if (t.input_nomTraitement || t.input_heureTraitement) {
  <span class="label">Traitement</span>
  <span class="value">
    @if (t.input_heureTraitement) {
    <span class="time-badge secondary">
      <mat-icon>schedule</mat-icon>
      {{ t.input_heureTraitement | carnetHeure }}
    </span>
    }
    @if (t.input_nomTraitement) {
    <span>{{ t.input_nomTraitement }}</span>
    }
  </span>
  }

  @if (getSommeilQualiteLabel()) {
  <span class="label">Nuit</span>
  <span class="value">
    @if (t.input_heureDernierReveil) {
    <span class="time-badge secondary">
      <mat-icon>schedule</mat-icon>
      Réveil {{ t.input_heureDernierReveil | carnetHeure }}
    </span>
    }
    <span class="sleep-quality" [class.agite]="getSommeilQualiteLabel() === 'Sommeil agité'">
      <mat-icon>{{ getSommeilQualiteLabel() === 'Bien dormi' ? 'check_circle' : 'warning' }}</mat-icon>
      {{ getSommeilQualiteLabel() }}
    </span>
  </span>
  }

  @if (t.input_heureDernierRepas) {
  <span class="label">Dernier repas</span>
  <span class="value">
    <span class="time-badge secondary">
      <mat-icon>schedule</mat-icon>
      {{ t.input_heureDernierRepas | carnetHeure }}
    </span>
  </span>
  }

  @if (t.input_heurePrevueDepart) {
  <span class="label">Départ prévu</span>
  <span class="value">
    <span class="time-badge secondary">
      <mat-icon>schedule</mat-icon>
      {{ t.input_heurePrevueDepart | carnetHeure }}
    </span>
    @if (t.select_personneAccompagnanteDepart) {
    <span class="muted">par {{ t.select_personneAccompagnanteDepart }}</span>
    }
  </span>
  }
</div>

@if (t.input_observation) {
<div class="observation-callout">
  <mat-icon class="quote-icon">format_quote</mat-icon>
  {{ t.input_observation }}
</div>
}
